export default {
    main: {
        borderBottom: "thin solid #e0e0e0"
    },
    description: {
        margin: "31px 0",
        fontSize: "16px",
        lineHeight: 1.38,
        color: "#7d7d7d"
    },
    cardLogo: {
        width: "77px",
        height: "25px",
        margin: "0 10px -5px"
    },
    cardDigits: {
        marginLeft: "15px"
    },
    price: {
        fontSize: "24px",
        fontWeight: 500,
        lineHeight: 0.92,
        color: "#7d7d7d",
        marginRight: "10px"
    },
    info: {
        paddingTop: "15px"
    },
    infoText: {
        fontSize: "16px",
        letterSpacing: "-0.2px",
        color: "rgba(0, 0, 0, 0.32)"
    },
    grayBackground: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#f5f5f5",
        zIndex: 999
    }
}